import type { ContractorPanelVisitsFilters } from "../components/ContractorPanelVisitsFilter";

/**
 * Returns new filters with date set. Clears "today and upcoming" when a date is set
 * (date and today filter are mutually exclusive).
 */
export function applyDateChange(
  prev: ContractorPanelVisitsFilters,
  date: string | undefined,
): ContractorPanelVisitsFilters {
  return {
    ...prev,
    date,
    ...(date ? { isTodayAndUpcoming: false } : {}),
  };
}

/**
 * Returns new filters with "today and upcoming" set. Clears date when enabling
 * (date and today filter are mutually exclusive).
 */
export function applyTodayFilterChange(
  prev: ContractorPanelVisitsFilters,
  isTodayAndUpcoming: boolean,
): ContractorPanelVisitsFilters {
  return {
    ...prev,
    isTodayAndUpcoming,
    ...(isTodayAndUpcoming ? { date: undefined } : {}),
  };
}
